// ...existing code...
import React, { useEffect, useState } from 'react';
import API from '../api';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';

export default function SearchOrders() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const isRtl = i18n.language === 'ar';

  const [orders, setOrders] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [drivers, setDrivers] = useState([]);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [driverId, setDriverId] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    API.get('customers/').then(r => setCustomers(r.data)).catch(()=>{});
    API.get('drivers/').then(r => setDrivers(r.data)).catch(()=>{});
  }, []);

  const fetchOrders = async () => {
    setLoading(true); setError('');
    try {
      const params = new URLSearchParams();
      if (startDate) params.append('start_date', startDate);
      if (endDate) params.append('end_date', endDate);
      if (customerId) params.append('customer', customerId);
      if (driverId) params.append('driver', driverId);
      if (status) params.append('status', status);

      const res = await API.get(`orders/?${params.toString()}`);
      setOrders(res.data || []);
    } catch (err) {
      console.error(err);
      setError(t('Failed to load orders'));
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const clearFilters = () => {
    setStartDate(''); setEndDate(''); setCustomerId(''); setDriverId(''); setStatus('');
    setOrders([]); setError('');
  };

  return (
    <div className={`page-container ${isRtl ? 'rtl' : ''}`}>
      <div className="page-header">
        <h2>{t('Search Orders')}</h2>
        <div className="header-actions">
          <button className="app-button" onClick={() => navigate('/')}>🏠 {t('Home')}</button>
          <button className="app-button outline" onClick={() => navigate(-1)}>{t('Back')}</button>
        </div>
      </div>

      <div className="search-card">
        <form className="search-grid" onSubmit={(e)=>{ e.preventDefault(); fetchOrders(); }}>
          <label>
            <div className="label">{t('Start Date')}</div>
            <input type="date" value={startDate} onChange={e=>setStartDate(e.target.value)} />
          </label>

          <label>
            <div className="label">{t('End Date')}</div>
            <input type="date" value={endDate} onChange={e=>setEndDate(e.target.value)} />
          </label>

          <label>
            <div className="label">{t('Customer')}</div>
            <select value={customerId} onChange={e=>setCustomerId(e.target.value)}>
              <option value="">{t('All')}</option>
              {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </label>

          <label>
            <div className="label">{t('Driver')}</div>
            <select value={driverId} onChange={e=>setDriverId(e.target.value)}>
              <option value="">{t('All')}</option>
              {drivers.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
            </select>
          </label>

          <label>
            <div className="label">{t('Status')}</div>
            <select value={status} onChange={e=>setStatus(e.target.value)}>
              <option value="">{t('All')}</option>
              <option value="pending">{t('Pending')}</option>
              <option value="confirmed">{t('Confirmed')}</option>
              <option value="assigned">{t('Assigned')}</option>
              <option value="picked_up">{t('Picked Up')}</option>
              <option value="in_transit">{t('In Transit')}</option>
              <option value="delivered">{t('Delivered')}</option>
              <option value="cancelled">{t('Cancelled')}</option>
            </select>
          </label>

          <div className="search-actions" style={{gridColumn: '1 / -1', justifySelf: isRtl ? 'start' : 'end'}}>
            <button type="submit" className="app-button">{t('Search')}</button>
            <button type="button" className="app-button outline" onClick={clearFilters} style={{marginLeft:8}}>{t('Clear')}</button>
          </div>
        </form>
      </div>

      <div style={{marginTop:18}}>
        {loading && <div className="muted">{t('Loading...')}</div>}
        {error && <div className="error">{error}</div>}
        {!loading && orders.length === 0 && !error && <div className="muted">{t('No orders found')}</div>}

        <ul className="orders-list">
          {orders.map(o => (
            <li key={o.id} className="order-item">
              <div className="order-row">
                <div className="order-left">
                  <div className="order-id">#{o.order_number || o.id}</div>
                  <div className="order-customer">{o.customer_name || (o.customer && o.customer.name) || o.customer}</div>
                  <div className="order-address">{(o.pickup_address || o.origin) || ''} → {(o.delivery_address || o.destination) || ''}</div>
                </div>

                <div className="order-right">
                  <div className={`status-pill status-${(o.status||'unknown')}`}>{t(o.status) || o.status}</div>
                  <div className="order-meta">{new Date(o.created_at).toLocaleString()}</div>
                  <div className="order-actions">
                    <button className="app-button small" onClick={() => {
                      // اقرأ لغة المستخدم الحالية من i18n العام (قرأتها مسبقاً من DB في index.js)
                      const lang = i18n.language || 'en';
                      window.open(`/orders/print/${o.id}?lang=${encodeURIComponent(lang)}`, '_blank');
                    }}>{t('Print')}</button>
                    <button className="app-button small outline" onClick={() => window.open(`/tracking/${o.id}`, '_blank')}>{t('Tracking')}</button>
                  </div>
                </div>
              </div>

              {o.description && <div className="order-desc">{o.description}</div>}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
// ...existing code...